import { Button, Card, CardActions, CardContent, CardHeader, Divider, CircularProgress } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import MailIcon from '@material-ui/icons/Mail';
import PrintIcon from '@material-ui/icons/Print';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import CiktiSmsGonder from 'src/components/PrintSmsSend';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { confirmAlert } from 'react-confirm-alert';
import axios from 'src/utils/axios';

const useStyles = makeStyles(theme => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700]
    },
    width: '100%'
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  content: {
    minHeight: 430,
  },
}));

function Yazdir({ className, FisNo, readonly, tasks, ...rest }) {
  const classes = useStyles();
  const [ciktiSms, setCiktiSms] = useState(false);
  const [ciktiTip, setCiktiTip] = useState(0);
  const [ciktiTipTxt, setCiktiTipTxt] = useState('');

  const [loading, setLoading] = useState(false);

  var DurumFisCiktiKontrol = false;
  var DurumRevizyonKartiKontrol = false;
  var DurumEvdeYokKontrol = false;


  let YazdirData = readonly ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : []) : loadBaslandiJob();

  if (!readonly && (!YazdirData || YazdirData.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      YazdirData = loadBaslandiJob();
    }
  }

  const durumKodu = (Array.isArray(YazdirData) && YazdirData.length > 0) ? (parseInt(YazdirData[0]?.SON_DURUM) || 0) : 0;

  const handleCiktiSmsClose = () => {
    setCiktiSms(false);
  }
  let YazdirMerkezeGonderData = readonly ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : []) : loadBaslandiJob();



  DurumFisCiktiKontrol = false;
  DurumRevizyonKartiKontrol = false;
  DurumEvdeYokKontrol = false;



  // React.useEffect(() => {
  if (!Array.isArray(YazdirMerkezeGonderData) || YazdirMerkezeGonderData.length === 0) {
    return null;
  }
  if ([4, 45, 18, 11, 23, 31].indexOf(parseInt(YazdirMerkezeGonderData[0]?.SON_DURUM)) !== -1) {
    DurumFisCiktiKontrol = true;
  }

  if ([10, 12, 46, 38, 11].indexOf(parseInt(YazdirMerkezeGonderData[0]?.SON_DURUM)) !== -1) {
    DurumRevizyonKartiKontrol = true;
  }
  if (YazdirMerkezeGonderData[0]?.SON_DURUM === 51) {
    DurumEvdeYokKontrol = true;
  }




  if (DurumFisCiktiKontrol === false
    && DurumRevizyonKartiKontrol === false
    && DurumEvdeYokKontrol === false
    && [23, 15, 31, 32].indexOf(parseInt(YazdirMerkezeGonderData[0]?.SON_DURUM)) === -1
  ) {
    DurumFisCiktiKontrol = true;
  }


  if ([21, 22, 33, 42].indexOf(parseInt(YazdirMerkezeGonderData[0]?.DurumKodu)) !== -1) {
    DurumFisCiktiKontrol = false;
    DurumRevizyonKartiKontrol = false;
    DurumEvdeYokKontrol = false;
  }

  const Onizleme = (event, ciktiTipi) => {
    var Link = process.env.REACT_APP_CIKTI_URL;
    if (ciktiTipi === 1) {
      Link = Link + 'FisCiktisi.html?GUID=' + YazdirMerkezeGonderData[0]?.WorkId;
    }
    if (ciktiTipi === 3) {
      Link = Link + 'RevizyonKarti.html?GUID=' + YazdirMerkezeGonderData[0]?.WorkId;
    }
    //Web satış faturasına yönlendirmek için 99 tanımlanmıştır. Artemis fiş çıktısı değildir.
    if (ciktiTipi === 99) {
      !YazdirMerkezeGonderData[0]?.WEB_SATIS_FATURA_PDF.startsWith('https://') ?
        Link = 'https://' : Link = '' //https yoksa hata veriyordu

      Link = Link + YazdirMerkezeGonderData[0]?.WEB_SATIS_FATURA_PDF;
    }
    event.persist();
    window.open(Link);
    event.persist();
  }

  const sendEmail = (data) => {
    confirmAlert({
      message: "Müşterimiz " + data.Musteri + " ın " + data.MusteriEmail + " adresine Fiş Çıktısı için email gönderilecektir. Onaylıyor musunuz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => sendEmailYes(data)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }

  const confirmOkey = (msg) => {
    confirmAlert({
      message: msg,
      buttons: [
        {
          label: 'Tamam',
          onClick: () => { return; }
        }
      ]
    });
  }

  const sendEmailYes = (data) => {
    setLoading(true);
    axios.get(`SendServicePaperEmail/${data.FisNo}`)
      .then(response => {
        confirmOkey(response.data.ErrorDescription);
        setLoading(false);
      }).catch(error => {
        confirmOkey("Bir Hata Oluştu: " + error.message);
        setLoading(false);
      });
  }

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader title="Merkeze Gönder Fiş Çıktısı"></CardHeader>
      <Divider />
      <CardContent className={classes.content}>
        {
          loading ?
            <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />
            : <div></div>
        }
        <div className={classes.wrapper}>
          <div className={classes.wrapper}>
            {DurumFisCiktiKontrol && (
              <div>
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitButton}
                  onClick={(e) => Onizleme(e, 1)}
                  disabled={[21, 22, 33, 42].includes(durumKodu)}
                  endIcon={<PrintIcon>Yazdır</PrintIcon>}
                >
                  Fiş Çıktısı Önizleme
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitButton}
                  onClick={() => {
                    setCiktiTip(1);
                    setCiktiTipTxt('Fiş Çıktısı');
                    setCiktiSms(true);
                  }}
                  disabled={[21, 22, 33, 42].includes(durumKodu)}
                  endIcon={<SendIcon>Yazdır</SendIcon>}
                >
                  Fiş Çıktısı Sms Gönder
                </Button>
                {
                  YazdirMerkezeGonderData?.[0]?.MusteriEmail?.length > 0 &&
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.submitButton}
                    onClick={() => sendEmail(YazdirMerkezeGonderData[0])}
                    disabled={[21, 22, 33, 42].includes(durumKodu)}
                    endIcon={<MailIcon />}
                  >
                    Fiş Çıktısı Email Gönder
                  </Button>
                }
              </div>
            )}
          </div>
          <div className={classes.wrapper}>
            {DurumRevizyonKartiKontrol && (
              <div>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={(e) => Onizleme(e, 3)}
                  disabled={[21, 22, 33, 42].includes(durumKodu)}
                  className={classes.submitButton}
                  endIcon={<PrintIcon>Yazdır</PrintIcon>}
                >
                  Revizyon Kartı Önizleme
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    setCiktiTip(3);
                    setCiktiTipTxt('Revizyon Kartı');
                    setCiktiSms(true);
                  }}
                  disabled={[21, 22, 33, 42].includes(durumKodu)}
                  className={classes.submitButton}
                  endIcon={<SendIcon>Revizyon Kartı</SendIcon>}
                >
                  Revizyon Kartı Sms Gönder
                </Button>
              </div>
            )}
          </div>
          <div className={classes.wrapper}>
            {YazdirMerkezeGonderData?.[0]?.WEB_SATIS_FATURA_PDF &&
              (<div>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={(e) => Onizleme(e, 99)}
                  className={classes.submitButton}
                  endIcon={<PrintIcon>Yazdır</PrintIcon>}
                >
                  Web Faturası Önizleme
                </Button>
              </div>)
            }
          </div>
        </div>
      </CardContent>
      <CardActions className={classes.actions}></CardActions>
      <CiktiSmsGonder onClose={handleCiktiSmsClose}
        forceOpen={() => setCiktiSms(true)}
        FisNo={FisNo}
        open={ciktiSms}
        ciktiTip={ciktiTip}
        ciktiTipTxt={ciktiTipTxt}
      />
    </Card>
  );
}

Yazdir.propTypes = {
  className: PropTypes.string
};

export default connect(state => ({ tasks: state.tasks1 }))(Yazdir);
